import { useMemo } from "react";

import { useMediaQuery, useTheme } from "@material-ui/core";

const DESKTOP_WIDTH = ["lg", "xl"];
const MOBILE_WIDTH = ["xs", "sm", "md"];

function useWidth() {
  const theme = useTheme();
  const keys = [...theme.breakpoints.keys].reverse();
  return (
    keys.reduce((output: any, key: any) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null) || "xs"
  );
}

function useLayout() {
  const theme = useTheme();
  const allWidth = [...theme.breakpoints.keys] as const;
  const width: typeof allWidth[number] = useWidth();

  const isDesktop = useMemo(() => {
    return DESKTOP_WIDTH.includes(width);
  }, [width]);

  const isMobile = useMemo(() => {
    return MOBILE_WIDTH.includes(width);
  }, [width]);

  const isXs = useMemo(() => {
    return ["xs"].includes(width);
  }, [width]);

  return {
    isDesktop: isDesktop,
    isMobile: isMobile,
    rawLayout: width,
    isXs,
  };
}

export default useLayout;
